<template>
  <v-container fluid>
    <v-card>
      <v-card-text>
        <v-row no-gutters :class="radecStyle.encabezado">
          <span>Listado de Contenedores</span>
          <v-spacer></v-spacer>
          <span>{{pageTitle}}</span>
        </v-row>
        <v-divider color="primary"></v-divider>
        <v-divider color="primary"></v-divider>
        <v-row no-gutters justify="space-around">
          <v-btn
            @click="refeshList('comprasInternacionales')"
            class="ma-2"
            tile
            outlined
            color="secondary"
          >
            <v-icon left>fas fa-ellipsis-h</v-icon>Ver todos
          </v-btn>
          <v-btn
            v-if="autorizadoAsignar"
            @click="refeshList('comercioInternacional')"
            class="ma-2"
            tile
            outlined
            color="secondary"
          >
            <v-icon left>fas fa-globe-americas</v-icon>Por asignar
          </v-btn>
          <v-btn
            v-if="autorizadoContabilidad"
            class="ma-2"
            @click="refeshList('contabilidad')"
            tile
            outlined
            color="secondary"
          >
            <v-icon left>fas fa-money-check-alt</v-icon>Por validar
          </v-btn>
          <v-btn
            @click="nuevoReporte()"
            class="ma-2"
            tile
            outlined
            color="primary"
            v-if="autorizadoSolicitar"
          >
            <v-icon left>fas fa-trailer</v-icon>Solicitar asignación
          </v-btn>
        </v-row>
        <template no-gutters justify="center" class="pt-6">
          <v-data-table
            :headers="headers"
            :items="desserts.Resultado"
            :footer-props="{
            itemsPerPageOptions: [1000], // -> Add this example
          }"
          >
            <template v-slot:item.ContainerRequestFolio="{ item }">
              <v-tooltip top>
                <template #activator="data">
                  <v-btn
                    color="secondary"
                    v-on="data.on"
                    @click="gotoDetail(item)"
                    text
                    x-small
                  >Comp - {{item.ContainerRequestFolio}}</v-btn>
                </template>
                <span>Solicitado por: {{item.ContainerRequestFullName}}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.SapOrder="{ item }">
              <v-btn
                @click="gotoProductList(item)"
                x-small
                text
                v-if="item.SapOrder"
                class="overline"
              >{{ item.SapOrder }}</v-btn>
            </template>
            <template v-slot:item.ContainerRequestProviderId="{ item }">
              <v-tooltip top>
                <template #activator="data">
                  <span
                    v-on="data.on"
                    class="overline"
                  >{{item.ContainerRequestProviderId}} - {{item.ContainerRequestProviderName}}</span>
                </template>
                <span>{{item.ContainerRequestFullName}}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.ContainerRequestInvoices="{ item }">
              <span class="overline">{{ item.ContainerRequestInvoices }}</span>
            </template>
            <template v-slot:item.ContainerNumber="{ item }">
              <span class="overline secondary--text">{{ item.ContainerNumber }}</span>
            </template>
            <template v-slot:item.ContainerRequestDate="{ item }">
              <span
                v-if="item.ContainerRequestDate"
                class="overline"
              >{{ item.ContainerRequestDate| moment("YYYY-MM-DD") }}</span>
            </template>
            <template v-slot:item.ContainerEtd="{ item }">
              <span
                v-if="item.ContainerEtd"
                class="overline"
              >{{ item.ContainerEtd| moment("YYYY-MM-DD") }}</span>
            </template>
            <template v-slot:item.ContainerEta="{ item }">
              <span
                v-if="item.ContainerEta"
                class="overline"
              >{{ item.ContainerEta| moment("YYYY-MM-DD ") }}</span>
            </template>
            <template v-slot:item.ContainerPreinvoicePasiveReady="{ item }">
              <v-tooltip top>
                <template #activator="data">
                  <span v-on="data.on">
                    <v-icon
                      v-if="item.ContainerNumberRegisterUser"
                      color="success"
                    >fas fa-globe-americas</v-icon>
                    <v-icon v-else color="warning" @click="gotoAsignar(item)">fas fa-globe-americas</v-icon>
                  </span>
                </template>
                <span
                  v-if="item.ContainerNumberRegisterUser"
                >Se agregó contenedor por: {{item.ContainerNumberRegisterFullName}}</span>
                <span v-else>Pendiente de asignar contenedor</span>
              </v-tooltip>
              <v-tooltip top>
                <template #activator="data">
                  <span v-on="data.on">
                    <v-icon
                      class="pl-2"
                      v-if="item.ContainerPreinvoicePasiveReady"
                      color="success"
                    >fas fa-money-check-alt</v-icon>
                    <v-icon
                      v-else
                      class="pl-2"
                      color="warning"
                      @click="gotoContabilidad(item)"
                    >fas fa-money-check-alt</v-icon>
                  </span>
                </template>
                <span
                  v-if="item.ContainerPreinvoicePasiveReady"
                >Considerado el:{{item.ContainerPreinvoicePasiveDate}}</span>
                <span v-else>Pendiente de considerar</span>
              </v-tooltip>
            </template>
            <template slot="footer">
              <v-row justify="end" class="font-italic font-weight-thin pr-3 pt-2">
                <span>* Da click en el folio para ver detalles del contenedor</span>
              </v-row>
              <v-row justify="end" class="font-italic font-weight-thin pr-3">
                <span>* Da click en la Orden de Compra SAP para ver productos del contenedor</span>
              </v-row>
            </template>
          </v-data-table>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from "vuex";
  export default {
    data: () => ({
      filter: "comprasInternacionales",

      headers: [
        {
          text: "Folio",
          align: "left",
          value: "ContainerRequestFolio"
        },
        {
          text: "Solicitud",
          align: "left",
          value: "ContainerRequestDate"
        },
        {
          text: "OC",
          align: "left",
          value: "SapOrder"
        },
        {
          text: "Proveedor",
          align: "left",
          value: "ContainerRequestProviderId"
        },
        {
          text: "Facturas",
          value: "ContainerRequestInvoices",
          align: "left"
        },
        {
          text: "Contenedor",
          value: "ContainerNumber",
          align: "left"
        },
        {
          text: "ETD",
          value: "ContainerEtd",
          align: "left"
        },
        {
          text: "ETA",
          value: "ContainerEta",
          align: "left"
        },

        {
          text: "",
          value: "ContainerPreinvoicePasiveReady",
          align: "center"
        }
      ]
    }),
    computed: {
      ...mapGetters({
        radecStyle: "getRadecStyle",
        desserts: "getContainerList",
        validaRol: "userInRol"
      }),
      autorizadoSolicitar() {
        return this.validaRol("SISCOM - Solicitar Asignacion de contenedor");
      },
      autorizadoAsignar() {
        return this.validaRol("SISCOM - Asignar Contenedor");
      },
      autorizadoContabilidad() {
        return this.validaRol("SISCOM - Prevision Contabilidad");
      },
      pageTitle() {
        switch (this.filter) {
          case "comprasInternacionales":
            return "Compras Internacionales";
          case "comercioInternacional":
            return "Pendientes de asignar contenedor";
          case "contabilidad":
            return "Pendientes de considerar por contabilidad";
        }
      }
      //OTRAS COMPUTED
    },
    methods: {
      ...mapActions({
        generaListado: "getContainerList"
      }),
      ...mapMutations({
        //resetForm: "resetState",
      }),
      refeshList(filter) {
        this.filter = filter;
        this.generaListado(this.filter);
      },
      nuevoReporte() {
        this.$router.push(`/international/container/new`);
      },
      gotoDetail(item) {
        console.log("Aqui se ira al detalle del contenedor");
        console.log(item.Id);
        this.$router.push(`/international/container/detail/${item.Id}`);
      },
      gotoProductList(item) {
        console.log("Aqui se ira al detalle de productos contenedor");
        console.log(item.Id);
        this.$router.push(
          `/patrimonial/transportexternoproducts/${item.Id}/${item.SapOrder}/${item.Container}`
        );
      },
      gotoAsignar(item) {
        console.log("Aqui se ira asignar contenedor");
        console.log(item.Id);
        if (!this.autorizadoAsignar) return;
        else {
          console.log("Permiso concedido...");
          this.$router.push(`/international/container/editComercio/${item.Id}`);
        }
        //this.$router.push(`/international/container/editComercio/${item.Id}`);
      },
      gotoContabilidad(item) {
        console.log("Aqui se ira confirmar contabilidad contenedor");
        console.log(item.Id);
        if (!this.autorizadoContabilidad) return;
        else {
          console.log("Permiso concedido...");
          this.$router.push(`/international/container/editConta/${item.Id}`);
        }
        //this.$router.push(`/international/container/editConta/${item.Id}`);
      }
    },
    created() {
      if (this.$route.params.filter != null)
        this.filter = this.$route.params.filter;
      this.generaListado(this.filter);
    },
    mounted() {},
    watch: {}
  };
</script>

<style scoped>
</style>